import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductosService } from 'src/app/services/productos.service';
import Swal from 'sweetalert2';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-productos',
  templateUrl: './productos.component.html',
  styleUrls: ['./productos.component.scss']
})
export class ProductosComponent implements OnInit {

  filterProducto = '';
  titulo: string;
  lista: any;
  productos = [];
  parametro: string;
  public user = this.authSvc.afAuth.user;
  usuario: any;
  perfil: any;
  tipo: string;
  usrType: string;
  userData: any;
  dist = false;

  listaPrd = [];

  constructor(private route: ActivatedRoute,
              private prodSvc: ProductosService,
              private router: Router,
              private authSvc: AuthService) {
  }
  ngOnInit(): void {
    this.loadUserStorage();
  }

  loadUserStorage(){
    if (localStorage.getItem('dataUserSupedido')) {
      this.userData = JSON.parse( localStorage.getItem('dataUserSupedido'));
     //. console.log(this.userData);
      if (this.userData.tipo === 'Distribuidor' && this.userData.estado === 'Activo') {
        this.prodSvc.cargarProductosDistribuidor().subscribe(prods => {
          this.lista = prods;
        });
      }
      if (this.userData.tipo === 'Cliente') {
        this.prodSvc.cargarProductosCliente().subscribe(prods => {
          this.lista = prods;

        });
      }
    } else {
      this.prodSvc.cargarProductosCliente().subscribe(prods => {
        this.lista = prods;
        localStorage.setItem('dataInventarioSupedido', JSON.stringify(this.lista));  
      });
    }
  }

  detalle(producto: any){
    if (this.usuario === null) {
      Swal.fire({
        title: 'No ha iniciado sesión',
        text: 'Por favor ingrese sus datos de usuario!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Ingresar!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.router.navigate(['home']);
        }
      });
    } else {
      this.prodSvc.producto = producto;
      this.router.navigate([`/producto/${producto.id}`]);
    }
  }
}

